@use '../../styles/variables.scss';
@use '../../styles/breakpoints.scss';

.reporting-page {
  padding: 2rem 3rem;

  @include breakpoints.breakpoint-sm-max {
    padding: 1.5rem 1rem;
  }
}

.reporting-page--tinted {
  background-color: variables.$in--black-12;
  padding-bottom: 3rem;
}

.inner {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  margin-inline: auto;
}

.inner--readable {
  max-width: variables.$page-max-width;
}

.inner--wide {
  max-width: 90rem;
}

.inner--full {
  max-width: none;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.header__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;

  > :first-child {
    margin: 0;
  }
}

.header__lead {
  max-width: 65ch;
  margin: 0;
}

.columns--with-aside {
  @include breakpoints.breakpoint-md {
    display: grid;
    grid-template-columns: 16rem minmax(0, 1fr);
    column-gap: 3rem;
    align-items: start;
  }
}

.aside {
  margin-block-end: 1.5rem;

  @include breakpoints.breakpoint-lg {
    position: sticky;
    top: 2rem;
    margin-block-end: 0;
  }
}
